var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStVincentAndTheGrenadines(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6525 1.98059C21.3793 0.740344 18.7722 0.0351562 16.0003 0.0351562C13.2284 0.0351562 10.6213 0.740344 8.3481 1.98059L6.95679 16.0352L8.3481 30.0897C10.6213 31.33 13.2284 32.0352 16.0003 32.0352C18.7722 32.0352 21.3793 31.33 23.6525 30.0897L25.0438 16.0352L23.6525 1.98059Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34781 30.0896V1.98055C3.37431 4.6943 0 9.97049 0 16.0352C0 22.0999 3.37431 27.3761 8.34781 30.0896Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9994 16.0352C31.9994 9.97049 28.6251 4.6943 23.6516 1.98055V30.0896C28.6251 27.3761 31.9994 22.0999 31.9994 16.0352V16.0352Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5215 20.2093L9.73877 16.0354L12.5214 11.8614L15.3041 16.0354L12.5215 20.2093Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4782 20.2093L16.6956 16.0354L19.4782 11.8614L22.2608 16.0354L19.4782 20.2093Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9994 25.7745L13.2168 21.6006L15.9994 17.4267L18.782 21.6006L15.9994 25.7745Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0351562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStVincentAndTheGrenadines);
export default __webpack_public_path__ + "static/media/st-vincent-and-the-grenadines.9048e3e8.svg";
export { ForwardRef as ReactComponent };